import type { FC } from 'react';
import React from 'react';
import { Helmet } from 'react-helmet';

import type { IProps } from './models';

export const Meta: FC<IProps> = ({ metaData }) => (
    <Helmet>
        {metaData.map(({ content, name, property }) => (
            <meta
                key={name || property}
                {...(name && { name })}
                {...(property && { property })}
                content={content}
            />
        ))}
    </Helmet>
);
